import { apiFetch } from "../utils/api";

const BASE = "/api/secondhand/v1";

async function parse(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.detail || data.message || "请求失败");
  }
  return data;
}

export function secondhandGet(path) {
  return apiFetch(`${BASE}${path}`).then(parse);
}

export function secondhandPost(path, body) {
  return apiFetch(`${BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then(parse);
}

export function secondhandPatch(path, body) {
  return apiFetch(`${BASE}${path}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then(parse);
}

export async function secondhandUploadImage(userId, file) {
  const form = new FormData();
  form.append("user_id", String(userId));
  form.append("file", file);
  const res = await apiFetch(`${BASE}/upload-image`, { method: "POST", body: form });
  return parse(res);
}
